import styled from "styled-components";

export const TextContainer = styled.div`
  margin: 20px 16px 0 16px;
`;
